export const dummyLogo = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpirPCq-KQAnJCQyJMmruwdPgR3-w1_a0neA&s";